export type AnomalyKind = 'thread' | 'bell' | 'mirror'

export type FxEvent =
  | { readonly type: 'stage'; readonly anomaly: AnomalyKind; readonly index: number }
  | { readonly type: 'scan'; readonly traits: readonly string[] }
  | { readonly type: 'stable'; readonly traits: readonly string[] }
  | { readonly type: 'breach'; readonly traits: readonly string[] }
  | { readonly type: 'reset' }

type FxListener = (event: FxEvent) => void

const listeners = new Set<FxListener>()

export function emitFx(event: FxEvent): void {
  for (const listener of listeners) listener(event)
}

export function onFx(listener: FxListener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
